import { LinkAnchorButton } from "lib/miolo";
import FundamenteiWithText from "components/branding/FundamenteiWithText";
import LogoSizingProps from "components/branding/LogoSizingProps";
import mediaQueries from "lib/utils/layout/mediaQueries";
import Link from "next/link";
import * as palette from "../palette";

export default function Header() {
  return (
    <header
      css={mediaQueries({
        display: "grid",
        gridColumnGap: 30,
        gridRowGap: 30,
        gridTemplateColumns: ["1fr", "max-content 1fr", "max-content 1fr", "max-content 1fr"],
        alignItems: "center",
        justifyContent: "center",
        maxWidth: 1140,
        padding: ["0 30px", null, null, null],
        textAlign: ["center", "left", "left", "left"],
      })}
    >
      <Link href="/">
        <a href="/" title="Fundamentei">
          <FundamenteiWithText className="inline-flex" {...LogoSizingProps.FundamenteiWithText.VERY_SMALL} />
        </a>
      </Link>

      <nav
        css={mediaQueries({
          display: "grid",
          gridRowGap: 30,
          gridColumnGap: 30,
          gridTemplateColumns: [
            "max-content",
            "repeat(2, max-content)",
            "repeat(2, max-content)",
            "repeat(2, max-content)",
          ],
          alignItems: "center",
          justifyContent: "center",
          marginLeft: [0, "auto", "auto", "auto"],
        })}
      >
        <div>
          <Link href="/login">
            <LinkAnchorButton
              href="/login"
              style={{
                fontSize: 16,
                fontWeight: 500,
                lineHeight: 1.33,
                letterSpacing: 1.6,
              }}
            >
              Login
            </LinkAnchorButton>
          </Link>
        </div>

        <Link href="/sign-up">
          <a
            href="/sign-up"
            css={{
              display: "inline-block",
              boxSizing: "border-box",
              margin: 0,
              padding: "8px 16px",
              overflow: "visible",
              color: palette.mariner,
              fontWeight: 500,
              fontSize: 16,
              lineHeight: 1.33,
              textDecoration: "none",
              border: `solid 1px ${palette.mariner}`,
              borderRadius: 20,
              transition: "all 60ms ease 0s",
              userSelect: "none",
              "&:hover": {
                color: palette.white,
                backgroundColor: palette.mariner,
              },
              "&:focus": {
                outline: "none",
                boxShadow: `${palette.tropicalBlue} 0px 0px 0px 3px`,
              },
              "&:active": {
                boxShadow: "transparent 0px 0px 0px 0px",
              },
              WebkitAppearance: "none",
            }}
          >
            Cadastre-se
          </a>
        </Link>
      </nav>
    </header>
  );
}
